const select =
  'created,generatedNumber,id,referenceExtraData,referenceItemDescription,referenceItemId';

export default {
  paged: {
    select: `${select}`,
    searchSelect: ['generatedNumber', 'referenceItemId', 'referenceItemDescription'],
    notSelectSearch: 'id,sequenceItem,referenceItemId',
    expand: {
      sequenceItem: { select: 'pattern' },
    },
  },
};
